import type { CSSProperties, ReactElement } from "react";
import { IconFile } from "@tabler/icons-react";
import { FAKE_COMMENT_FILE_ACTION } from "@/components/ui/Cfakecomment";
import type { FakeCommentFileAttachment } from "@/components/ui/Cfakecomment";
import { GLASS_SHADOW, MINT } from "./chatteaser3.constants";
// The file attachment is the chosen "Glass mint" tile: a mint-tinted frosted tile
// with a glass icon box, action label + filename, and a version badge.
const FILE_ADDED_VERSION_LABEL = "V1";
const FILE_EDITED_VERSION_LABEL = "V4";
const FILE_ADDED_ACTION_WORD = "Added";
const FILE_EDITED_ACTION_WORD = "Edited";
const FILE_DARK_TEXT_COLOR = "#08130d";
export function Chatteaser3FileChip({ file, }: {
    file: FakeCommentFileAttachment;
}): ReactElement {
    const action = getFileActionWord(file);
    const name = getFileDisplayName(file.fileName);
    const version = getFileVersion(file);
    return (
      <span data-el="Cchatteaser3/FileChip/Root" style={MINT_TILE_STYLE}>
        <span style={MINT_ICON_STYLE}>
          <IconFile size={18} color={MINT}/>
        </span>
        <span style={TEXT_COLUMN_STYLE}>
          <span style={ACTION_LABEL_STYLE}>
            {`${action} a file`}
          </span>
          <span style={NAME_STYLE}>
            {name}
          </span>
        </span>
        <span style={VERSION_BADGE_STYLE}>
          {version}
        </span>
      </span>
    );
}
function getFileDisplayName(fileName: string): string {
    const dot = fileName.lastIndexOf(".");
    return dot > 0 ? fileName.slice(0, dot) : fileName;
}
function getFileVersion(file: FakeCommentFileAttachment): string {
    if (file.versionLabel)
        return file.versionLabel.toUpperCase();
    return file.action === FAKE_COMMENT_FILE_ACTION.Added
        ? FILE_ADDED_VERSION_LABEL
        : FILE_EDITED_VERSION_LABEL;
}
function getFileActionWord(file: FakeCommentFileAttachment): string {
    return file.action === FAKE_COMMENT_FILE_ACTION.Added
        ? FILE_ADDED_ACTION_WORD
        : FILE_EDITED_ACTION_WORD;
}
const MINT_TILE_STYLE: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 14,
    padding: "10px 16px",
    borderRadius: 18,
    backgroundColor: "rgba(95,243,184,0.05)",
    border: "1px solid rgba(95,243,184,0.18)",
    boxShadow: GLASS_SHADOW,
};
const MINT_ICON_STYLE: CSSProperties = {
    width: 36,
    height: 36,
    flexShrink: 0,
    borderRadius: 11,
    backgroundColor: "rgba(95,243,184,0.1)",
    border: "1px solid rgba(95,243,184,0.2)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
};
const TEXT_COLUMN_STYLE: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: 1,
};
const ACTION_LABEL_STYLE: CSSProperties = {
    fontSize: 13,
    color: "rgba(95,243,184,0.72)",
};
const NAME_STYLE: CSSProperties = {
    fontSize: 17,
    color: "rgba(255,255,255,0.92)",
};
const VERSION_BADGE_STYLE: CSSProperties = {
    fontSize: 12,
    fontWeight: 700,
    color: FILE_DARK_TEXT_COLOR,
    backgroundColor: MINT,
    borderRadius: 7,
    padding: "3px 8px",
    marginLeft: 4,
};
